module.exports = __webpack_public_path__ + "static/media/substituion-period-list.c555194f.svg";